export default __webpack_public_path__ + "static/media/wlv.816c7c35.svg";